import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49b18ddd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "top white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "case" }, null, -1))
const _hoisted_4 = { class: "grid max" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "h2",
    id: "font-size"
  }, "Send Us a Message"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "h4",
    id: "font-size"
  }, " Please leave your contact information. Our team will reach out to you shortly. ")
], -1))
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "cols col2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18 required-field",
  id: "font-size"
}, "I am interested in", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "cols" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18 required-field",
  id: "font-size"
}, "First Name", -1))
const _hoisted_13 = { class: "cols" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18 mm20 required-field",
  id: "font-size"
}, "Last Name", -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "cols col2" }
const _hoisted_17 = {
  class: "ft18 required-field",
  id: "font-size"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "cols col2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18",
  id: "font-size"
}, "Job Title", -1))
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "cols mm30" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18",
  id: "font-size"
}, "Country", -1))
const _hoisted_24 = { class: "cols" }
const _hoisted_25 = {
  class: "ft18",
  id: "font-size"
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "cols col2" }
const _hoisted_28 = {
  class: "ft18",
  id: "font-size"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "cols col2" }
const _hoisted_31 = { class: "ft18" }
const _hoisted_32 = { class: "flex" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "cols col2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18 required-field",
  id: "font-size"
}, "Work Phone", -1))
const _hoisted_36 = { class: "flex" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "cols col2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18",
  id: "font-size"
}, "Company website link", -1))
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "cols col2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18",
  id: "font-size"
}, "LinkedIn", -1))
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "cols col2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18",
  id: "font-size"
}, "Reason of outreach", -1))
const _hoisted_46 = { class: "flex" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "cols col2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ft18",
  id: "font-size"
}, "Message", -1))
const _hoisted_50 = { class: "row" }
const _hoisted_51 = {
  method: "POST",
  action: "https://apifiny.activehosted.com/proc.php",
  id: "_form_16_",
  class: "_form _form_16 _inline-form _dark",
  novalidate: ""
}
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<input type=\"hidden\" name=\"u\" value=\"16\" data-v-49b18ddd><input type=\"hidden\" name=\"f\" value=\"16\" data-v-49b18ddd><input type=\"hidden\" name=\"s\" data-v-49b18ddd><input type=\"hidden\" name=\"c\" value=\"0\" data-v-49b18ddd><input type=\"hidden\" name=\"m\" value=\"0\" data-v-49b18ddd><input type=\"hidden\" name=\"act\" value=\"sub\" data-v-49b18ddd><input type=\"hidden\" name=\"v\" value=\"2\" data-v-49b18ddd><input type=\"hidden\" name=\"or\" value=\"21eed4176730b566b611471600851094\" data-v-49b18ddd>", 8)
const _hoisted_60 = { class: "_form-content" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_form_element _x71727573 _full_width _clear" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_form-title" }, "Subscribe for Email Updates")
], -1))
const _hoisted_62 = { class: "_form_element _x80337498 _full_width" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "_form-label"
}, " First Name* ", -1))
const _hoisted_64 = { class: "_field-wrapper" }
const _hoisted_65 = ["error", "errMsg", "value"]
const _hoisted_66 = { class: "_form_element _x35719816 _full_width" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "_form-label"
}, " Last Name* ", -1))
const _hoisted_68 = { class: "_field-wrapper" }
const _hoisted_69 = ["value"]
const _hoisted_70 = { class: "_form_element _x11924557 _full_width" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "_form-label"
}, " Work Email* ", -1))
const _hoisted_72 = { class: "_field-wrapper" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "_form_element _x66728513 _full_width" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "_form-label"
}, " Work Phone ", -1))
const _hoisted_76 = { class: "_field-wrapper" }
const _hoisted_77 = ["value"]
const _hoisted_78 = { class: "_form_element _field26 _full_width" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[26]",
  class: "_form-label"
}, " Message ", -1))
const _hoisted_80 = { class: "_field-wrapper" }
const _hoisted_81 = ["value"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_button-wrapper _full_width" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "_form_16_submit",
    class: "_submit",
    type: "submit"
  }, "Submit")
], -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_clear-element" }, null, -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_form-thank-you",
  style: {"display":"none"}
}, null, -1))
const _hoisted_85 = {
  method: "POST",
  action: "https://apifiny.activehosted.com/proc.php",
  id: "_form_12_",
  class: "_form _form_12 _inline-form _dark",
  novalidate: ""
}
const _hoisted_86 = /*#__PURE__*/_createStaticVNode("<input type=\"hidden\" name=\"u\" value=\"12\" data-v-49b18ddd><input type=\"hidden\" name=\"f\" value=\"12\" data-v-49b18ddd><input type=\"hidden\" name=\"s\" data-v-49b18ddd><input type=\"hidden\" name=\"c\" value=\"0\" data-v-49b18ddd><input type=\"hidden\" name=\"m\" value=\"0\" data-v-49b18ddd><input type=\"hidden\" name=\"act\" value=\"sub\" data-v-49b18ddd><input type=\"hidden\" name=\"v\" value=\"2\" data-v-49b18ddd><input type=\"hidden\" name=\"or\" value=\"e1c5e151309f34d530810a2d7f82155b\" data-v-49b18ddd>", 8)
const _hoisted_94 = { class: "_form-content" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_form_element _x68644479 _full_width _clear" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_form-title" }, "Subscribe for Email Updates")
], -1))
const _hoisted_96 = { class: "_form_element _x48507858 _full_width" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "_form-label"
}, " First Name* ", -1))
const _hoisted_98 = { class: "_field-wrapper" }
const _hoisted_99 = ["value"]
const _hoisted_100 = { class: "_form_element _x05009491 _full_width" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "_form-label"
}, " Last Name* ", -1))
const _hoisted_102 = { class: "_field-wrapper" }
const _hoisted_103 = ["value"]
const _hoisted_104 = { class: "_form_element _x57477452 _full_width" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "_form-label"
}, " Business Email* ", -1))
const _hoisted_106 = { class: "_field-wrapper" }
const _hoisted_107 = ["value"]
const _hoisted_108 = { class: "_form_element _field7 _full_width" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[7]",
  class: "_form-label"
}, " Country* ", -1))
const _hoisted_110 = { class: "_field-wrapper" }
const _hoisted_111 = ["value"]
const _hoisted_112 = { class: "_form_element _field6 _full_width" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[6]",
  class: "_form-label"
}, " Region ", -1))
const _hoisted_114 = { class: "_field-wrapper" }
const _hoisted_115 = ["value"]
const _hoisted_116 = { class: "_form_element _field51 _full_width" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[51]",
  class: "_form-label"
}, " Organization Name* ", -1))
const _hoisted_118 = { class: "_field-wrapper" }
const _hoisted_119 = ["value"]
const _hoisted_120 = { class: "_form_element _field53 _full_width" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[53]",
  class: "_form-label"
}, " Organization Type* ", -1))
const _hoisted_122 = { class: "_field-wrapper" }
const _hoisted_123 = ["value"]
const _hoisted_124 = /*#__PURE__*/_createStaticVNode("<option selected data-v-49b18ddd></option><option value=\"Bank\" data-v-49b18ddd>Bank</option><option value=\"Digital Bank\" data-v-49b18ddd>Digital Bank</option><option value=\"Credit Union\" data-v-49b18ddd>Credit Union</option><option value=\"Exchange\" data-v-49b18ddd>Exchange</option><option value=\"Service Bureau\" data-v-49b18ddd>Service Bureau</option><option value=\"Payment Remittance Company\" data-v-49b18ddd>Payment Remittance Company</option><option value=\"Business\" data-v-49b18ddd>Business</option><option value=\"Other\" data-v-49b18ddd>Other</option>", 9)
const _hoisted_133 = [
  _hoisted_124
]
const _hoisted_134 = { class: "_form_element _x07804020 _full_width" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "_form-label"
}, " Phone Number ", -1))
const _hoisted_136 = { class: "_field-wrapper" }
const _hoisted_137 = ["value"]
const _hoisted_138 = { class: "_form_element _field46 _full_width" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[46]",
  class: "_form-label"
}, " Company website link* ", -1))
const _hoisted_140 = { class: "_field-wrapper" }
const _hoisted_141 = ["value"]
const _hoisted_142 = { class: "_form_element _field3 _full_width" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[3]",
  class: "_form-label"
}, " LinkedIn ", -1))
const _hoisted_144 = { class: "_field-wrapper" }
const _hoisted_145 = ["value"]
const _hoisted_146 = { class: "_form_element _field26 _full_width" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[26]",
  class: "_form-label"
}, " Message ", -1))
const _hoisted_148 = { class: "_field-wrapper" }
const _hoisted_149 = ["value"]
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_button-wrapper _full_width" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "_form_12_submit",
    class: "_submit",
    type: "submit"
  }, "Submit")
], -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_clear-element" }, null, -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_form-thank-you",
  style: {"display":"none"}
}, null, -1))
const _hoisted_153 = {
  method: "POST",
  action: "https://apifiny.activehosted.com/proc.php",
  id: "_form_14_",
  class: "_form _form_14 _inline-form _dark",
  novalidate: ""
}
const _hoisted_154 = /*#__PURE__*/_createStaticVNode("<input type=\"hidden\" name=\"u\" value=\"14\" data-v-49b18ddd><input type=\"hidden\" name=\"f\" value=\"14\" data-v-49b18ddd><input type=\"hidden\" name=\"s\" data-v-49b18ddd><input type=\"hidden\" name=\"c\" value=\"0\" data-v-49b18ddd><input type=\"hidden\" name=\"m\" value=\"0\" data-v-49b18ddd><input type=\"hidden\" name=\"act\" value=\"sub\" data-v-49b18ddd><input type=\"hidden\" name=\"v\" value=\"2\" data-v-49b18ddd><input type=\"hidden\" name=\"or\" value=\"db5223f406878fadd4d0dacd9c461a27\" data-v-49b18ddd>", 8)
const _hoisted_162 = { class: "_form-content" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_form_element _x09486278 _full_width _clear" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_form-title" }, "Subscribe for Email Updates")
], -1))
const _hoisted_164 = { class: "_form_element _x27732840 _full_width" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "_form-label"
}, " First Name* ", -1))
const _hoisted_166 = { class: "_field-wrapper" }
const _hoisted_167 = ["value"]
const _hoisted_168 = { class: "_form_element _x57765106 _full_width" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "_form-label"
}, " Last Name* ", -1))
const _hoisted_170 = { class: "_field-wrapper" }
const _hoisted_171 = ["value"]
const _hoisted_172 = { class: "_form_element _x91358855 _full_width" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "_form-label"
}, " Email* ", -1))
const _hoisted_174 = { class: "_field-wrapper" }
const _hoisted_175 = ["value"]
const _hoisted_176 = { class: "_form_element _field42 _full_width" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[42]",
  class: "_form-label"
}, " Job Title* ", -1))
const _hoisted_178 = { class: "_field-wrapper" }
const _hoisted_179 = ["value"]
const _hoisted_180 = { class: "_form_element _field7 _full_width" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[7]",
  class: "_form-label"
}, " Country* ", -1))
const _hoisted_182 = { class: "_field-wrapper" }
const _hoisted_183 = ["value"]
const _hoisted_184 = { class: "_form_element _field6 _full_width" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[6]",
  class: "_form-label"
}, " Region ", -1))
const _hoisted_186 = { class: "_field-wrapper" }
const _hoisted_187 = ["value"]
const _hoisted_188 = { class: "_form_element _field51 _full_width" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[51]",
  class: "_form-label"
}, " Organization Name* ", -1))
const _hoisted_190 = { class: "_field-wrapper" }
const _hoisted_191 = ["value"]
const _hoisted_192 = { class: "_form_element _field54 _full_width" }
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[54]",
  class: "_form-label"
}, " Organization Type* ", -1))
const _hoisted_194 = { class: "_field-wrapper" }
const _hoisted_195 = ["value"]
const _hoisted_196 = /*#__PURE__*/_createStaticVNode("<option selected data-v-49b18ddd></option><option value=\"Bank\" data-v-49b18ddd>Bank</option><option value=\"Central Bank\" data-v-49b18ddd>Central Bank</option><option value=\"Government\" data-v-49b18ddd>Government</option><option value=\"Other\" data-v-49b18ddd>Other</option>", 5)
const _hoisted_201 = [
  _hoisted_196
]
const _hoisted_202 = { class: "_form_element _x57123524 _full_width" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "_form-label"
}, " Phone Number ", -1))
const _hoisted_204 = { class: "_field-wrapper" }
const _hoisted_205 = ["value"]
const _hoisted_206 = { class: "_form_element _field46 _full_width" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[46]",
  class: "_form-label"
}, " Company website lnk ", -1))
const _hoisted_208 = { class: "_field-wrapper" }
const _hoisted_209 = ["value"]
const _hoisted_210 = { class: "_form_element _field55 _full_width" }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[55]",
  class: "_form-label"
}, " Reason of outreach* ", -1))
const _hoisted_212 = { class: "_field-wrapper" }
const _hoisted_213 = ["value"]
const _hoisted_214 = /*#__PURE__*/_createStaticVNode("<option selected data-v-49b18ddd></option><option value=\"Issuing your own digital currency\" data-v-49b18ddd> Issuing your own digital currency </option><option value=\"Deploy your own CBDC\" data-v-49b18ddd>Deploy your own CBDC</option><option value=\"Learn about CBDC\" data-v-49b18ddd>Learn about CBDC</option><option value=\"Integrate with Roxe global network\" data-v-49b18ddd> Integrate with Roxe global network </option><option value=\"Interested in a CBDC pilot\" data-v-49b18ddd>Interested in a CBDC pilot</option><option value=\"Other\" data-v-49b18ddd>Other</option>", 7)
const _hoisted_221 = [
  _hoisted_214
]
const _hoisted_222 = { class: "_form_element _field26 _full_width" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[26]",
  class: "_form-label"
}, " Roxe Form Message ", -1))
const _hoisted_224 = { class: "_field-wrapper" }
const _hoisted_225 = ["value"]
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_button-wrapper _full_width" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "_form_14_submit",
    class: "_submit",
    type: "submit"
  }, "Submit")
], -1))
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_clear-element" }, null, -1))
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_form-thank-you",
  style: {"display":"none"}
}, null, -1))
const _hoisted_229 = {
  method: "POST",
  action: "https://apifiny.activehosted.com/proc.php",
  id: "_form_15_",
  class: "_form _form_15 _inline-form _dark",
  novalidate: ""
}
const _hoisted_230 = /*#__PURE__*/_createStaticVNode("<input type=\"hidden\" name=\"u\" value=\"15\" data-v-49b18ddd><input type=\"hidden\" name=\"f\" value=\"15\" data-v-49b18ddd><input type=\"hidden\" name=\"s\" data-v-49b18ddd><input type=\"hidden\" name=\"c\" value=\"0\" data-v-49b18ddd><input type=\"hidden\" name=\"m\" value=\"0\" data-v-49b18ddd><input type=\"hidden\" name=\"act\" value=\"sub\" data-v-49b18ddd><input type=\"hidden\" name=\"v\" value=\"2\" data-v-49b18ddd><input type=\"hidden\" name=\"or\" value=\"3bfabde03a96120ce04655150eca4057\" data-v-49b18ddd>", 8)
const _hoisted_238 = { class: "_form-content" }
const _hoisted_239 = { class: "_form_element _x62964354 _full_width" }
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "_form-label"
}, " First Name* ", -1))
const _hoisted_241 = { class: "_field-wrapper" }
const _hoisted_242 = ["value"]
const _hoisted_243 = { class: "_form_element _x90555467 _full_width" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "_form-label"
}, " Last Name* ", -1))
const _hoisted_245 = { class: "_field-wrapper" }
const _hoisted_246 = ["value"]
const _hoisted_247 = { class: "_form_element _field42 _full_width" }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[42]",
  class: "_form-label"
}, " Your Title* ", -1))
const _hoisted_249 = { class: "_field-wrapper" }
const _hoisted_250 = ["value"]
const _hoisted_251 = { class: "_form_element _x87681811 _full_width" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "_form-label"
}, " Email* ", -1))
const _hoisted_253 = { class: "_field-wrapper" }
const _hoisted_254 = ["value"]
const _hoisted_255 = { class: "_form_element _x45812775 _full_width" }
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "_form-label"
}, " Phone ", -1))
const _hoisted_257 = { class: "_field-wrapper" }
const _hoisted_258 = ["value"]
const _hoisted_259 = { class: "_form_element _field43 _full_width" }
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[43]",
  class: "_form-label"
}, " Business/Organization Name* ", -1))
const _hoisted_261 = { class: "_field-wrapper" }
const _hoisted_262 = ["value"]
const _hoisted_263 = { class: "_form_element _field6 _full_width" }
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[6]",
  class: "_form-label"
}, " State* ", -1))
const _hoisted_265 = { class: "_field-wrapper" }
const _hoisted_266 = ["value"]
const _hoisted_267 = { class: "_form_element _field7 _full_width" }
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[7]",
  class: "_form-label"
}, " Country ", -1))
const _hoisted_269 = { class: "_field-wrapper" }
const _hoisted_270 = ["value"]
const _hoisted_271 = { class: "_form_element _field26 _full_width" }
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "field[26]",
  class: "_form-label"
}, " Your inquiries ", -1))
const _hoisted_273 = { class: "_field-wrapper" }
const _hoisted_274 = ["value"]
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_button-wrapper _full_width" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "_form_15_submit",
    class: "_submit",
    type: "submit"
  }, " Submit ")
], -1))
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_clear-element" }, null, -1))
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_form-thank-you",
  style: {"display":"none"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_r_select = _resolveComponent("r-select")!
  const _component_r_input = _resolveComponent("r-input")!
  const _component_r_button = _resolveComponent("r-button")!
  const _component_Tail = _resolveComponent("Tail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, { theme: "white" })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_r_select, {
              placeholder: "Select your segment",
              modelValue: _ctx.data.inster,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.inster) = $event)),
              items: _ctx.items
            }, null, 8, ["modelValue", "items"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_r_input, {
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handfirst(true))),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handfirst())),
              error: _ctx.data.first.error,
              errMsg: _ctx.data.first.msg,
              placeholder: "First Name",
              modelValue: _ctx.data.first.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.first.value) = $event))
            }, null, 8, ["error", "errMsg", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_r_input, {
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handfirst(false))),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handfirst(false))),
              error: _ctx.data.last.error,
              errMsg: _ctx.data.last.msg,
              placeholder: "Last Name",
              modelValue: _ctx.data.last.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.last.value) = $event))
            }, null, 8, ["error", "errMsg", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formIndex == 3 ? "Business Email" : "Work Email"), 1),
            _createVNode(_component_r_input, {
              onChange: _ctx.handlemail,
              onBlur: _ctx.handlemail,
              reg: "^(\\w+\\.*\\w+)*\\@(\\w+\\.*\\w+)*$",
              errMsg: _ctx.data.email.msg,
              error: _ctx.data.email.error,
              placeholder: _ctx.formIndex == 3 ? 'Email Address' : 'Email Address',
              modelValue: _ctx.data.email.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.email.value) = $event))
            }, null, 8, ["onChange", "onBlur", "errMsg", "error", "placeholder", "modelValue"])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_r_input, {
              placeholder: "Job Title",
              modelValue: _ctx.data.job,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.job) = $event))
            }, null, 8, ["modelValue"])
          ])
        ], 512), [
          [_vShow, _ctx.formIndex >= 2]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_r_input, {
              placeholder: "Country",
              modelValue: _ctx.data.countryId,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.countryId) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formIndex==3?"State":"Region"), 1),
            _createVNode(_component_r_input, {
              placeholder: _ctx.formIndex==3?'State':'Region',
              modelValue: _ctx.data.region,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data.region) = $event))
            }, null, 8, ["placeholder", "modelValue"])
          ])
        ], 512), [
          [_vShow, _ctx.formIndex >= 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formIndex == 3 ? "Business/Organization Name*" : "Organization Name"), 1),
            _createVNode(_component_r_input, {
              placeholder: _ctx.formIndex == 3 ? 'Business/Organization Name*' : 'Organization Name',
              modelValue: _ctx.data.organization,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.organization) = $event))
            }, null, 8, ["placeholder", "modelValue"])
          ])
        ], 512), [
          [_vShow, _ctx.formIndex >= 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formIndex == 3 ? "Company Type" : "Organization Type"), 1),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_r_select, {
                items: _ctx.orgList,
                modelValue: _ctx.data.orgType,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.orgType) = $event)),
                placeholder: _ctx.formIndex == 3 ? 'Company Type' : 'Organization Type'
              }, null, 8, ["items", "modelValue", "placeholder"])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.formIndex >= 1 && _ctx.formIndex!=3]
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_r_select, {
                style: { width: '20%', marginRight: '10px' },
                items: _ctx.PhList,
                onCommand: _ctx.handcmd,
                modelValue: _ctx.data.country,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.country) = $event)),
                placeholder: "+1"
              }, null, 8, ["items", "onCommand", "modelValue"]),
              _createVNode(_component_r_input, {
                ref: "form",
                reg: "^\\d+$",
                style: { flexGrow: 1 },
                placeholder: "Phone Number",
                errMsg: _ctx.data.phone.msg,
                error: _ctx.data.phone.error,
                modelValue: _ctx.data.phone.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.data.phone.value) = $event))
              }, null, 8, ["errMsg", "error", "modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(_component_r_input, {
              placeholder: "Company website link",
              modelValue: _ctx.data.website,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.data.website) = $event))
            }, null, 8, ["modelValue"])
          ])
        ], 512), [
          [_vShow, _ctx.formIndex >= 1 && _ctx.formIndex!=3]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createVNode(_component_r_input, {
              placeholder: "LinkedIn",
              modelValue: _ctx.data.linkin,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.data.linkin) = $event))
            }, null, 8, ["modelValue"])
          ])
        ], 512), [
          [_vShow, _ctx.formIndex == 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_r_select, {
                items: _ctx.reasonList,
                modelValue: _ctx.data.reason,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.data.reason) = $event)),
                placeholder: "Reason of outreach"
              }, null, 8, ["items", "modelValue"])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.formIndex >= 2 && _ctx.formIndex!=3]
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createVNode(_component_r_input, {
              class: "",
              type: "textarea",
              placeholder: "What are you interested in?",
              modelValue: _ctx.data.message,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.data.message) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_r_button, {
            onClick: _ctx.handsubmit,
            id: "font-size"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Submit")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("form", _hoisted_51, [
      _hoisted_52,
      _createElementVNode("div", _hoisted_60, [
        _hoisted_61,
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("input", {
              error: _ctx.data.first.err,
              errMsg: _ctx.data.first.msg,
              value: _ctx.data.first.value,
              type: "text",
              id: "firstname",
              name: "firstname",
              placeholder: "Type your first name",
              required: ""
            }, null, 8, _hoisted_65)
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("input", {
              type: "text",
              value: _ctx.data.last.value,
              id: "lastname",
              name: "lastname",
              placeholder: "Type your last name",
              required: ""
            }, null, 8, _hoisted_69)
          ])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("input", {
              type: "text",
              id: "email",
              name: "email",
              value: _ctx.data.email.value,
              placeholder: "Type your email",
              required: ""
            }, null, 8, _hoisted_73)
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("input", {
              value: `${_ctx.data.country}${_ctx.data.phone.value}`,
              type: "text",
              id: "phone",
              name: "phone",
              placeholder: "Type your phone number"
            }, null, 8, _hoisted_77)
          ])
        ]),
        _createElementVNode("div", _hoisted_78, [
          _hoisted_79,
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("textarea", {
              value: _ctx.data.message,
              id: "field[26]",
              name: "field[26]",
              placeholder: ""
            }, null, 8, _hoisted_81)
          ])
        ]),
        _hoisted_82,
        _hoisted_83
      ]),
      _hoisted_84
    ], 512), [
      [_vShow, false]
    ]),
    _withDirectives(_createElementVNode("form", _hoisted_85, [
      _hoisted_86,
      _createElementVNode("div", _hoisted_94, [
        _hoisted_95,
        _createElementVNode("div", _hoisted_96, [
          _hoisted_97,
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("input", {
              value: _ctx.data.first.value,
              type: "text",
              id: "firstname",
              name: "firstname",
              placeholder: "Type your first name",
              required: ""
            }, null, 8, _hoisted_99)
          ])
        ]),
        _createElementVNode("div", _hoisted_100, [
          _hoisted_101,
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("input", {
              type: "text",
              value: _ctx.data.last.value,
              id: "lastname",
              name: "lastname",
              placeholder: "Type your last name",
              required: ""
            }, null, 8, _hoisted_103)
          ])
        ]),
        _createElementVNode("div", _hoisted_104, [
          _hoisted_105,
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("input", {
              type: "text",
              id: "email",
              name: "email",
              value: _ctx.data.email.value,
              placeholder: "Type your email",
              required: ""
            }, null, 8, _hoisted_107)
          ])
        ]),
        _createElementVNode("div", _hoisted_108, [
          _hoisted_109,
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("input", {
              type: "text",
              id: "field[7]",
              name: "field[7]",
              value: _ctx.data.countryId,
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_111)
          ])
        ]),
        _createElementVNode("div", _hoisted_112, [
          _hoisted_113,
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("input", {
              type: "text",
              id: "field[6]",
              name: "field[6]",
              value: _ctx.data.region,
              placeholder: ""
            }, null, 8, _hoisted_115)
          ])
        ]),
        _createElementVNode("div", _hoisted_116, [
          _hoisted_117,
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("input", {
              type: "text",
              id: "field[51]",
              name: "field[51]",
              value: _ctx.data.organization,
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_119)
          ])
        ]),
        _createElementVNode("div", _hoisted_120, [
          _hoisted_121,
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("select", {
              value: _ctx.data.orgType,
              name: "field[53]",
              id: "field[53]",
              required: ""
            }, _hoisted_133, 8, _hoisted_123)
          ])
        ]),
        _createElementVNode("div", _hoisted_134, [
          _hoisted_135,
          _createElementVNode("div", _hoisted_136, [
            _createElementVNode("input", {
              type: "text",
              id: "phone",
              value: _ctx.phonenum,
              name: "phone",
              placeholder: "Type your phone number"
            }, null, 8, _hoisted_137)
          ])
        ]),
        _createElementVNode("div", _hoisted_138, [
          _hoisted_139,
          _createElementVNode("div", _hoisted_140, [
            _createElementVNode("input", {
              value: _ctx.data.website,
              type: "text",
              id: "field[46]",
              name: "field[46]",
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_141)
          ])
        ]),
        _createElementVNode("div", _hoisted_142, [
          _hoisted_143,
          _createElementVNode("div", _hoisted_144, [
            _createElementVNode("input", {
              type: "text",
              id: "field[3]",
              name: "field[3]",
              value: _ctx.data.linkin,
              placeholder: ""
            }, null, 8, _hoisted_145)
          ])
        ]),
        _createElementVNode("div", _hoisted_146, [
          _hoisted_147,
          _createElementVNode("div", _hoisted_148, [
            _createElementVNode("textarea", {
              value: _ctx.data.message,
              id: "field[26]",
              name: "field[26]",
              placeholder: ""
            }, null, 8, _hoisted_149)
          ])
        ]),
        _hoisted_150,
        _hoisted_151
      ]),
      _hoisted_152
    ], 512), [
      [_vShow, false]
    ]),
    _withDirectives(_createElementVNode("form", _hoisted_153, [
      _hoisted_154,
      _createElementVNode("div", _hoisted_162, [
        _hoisted_163,
        _createElementVNode("div", _hoisted_164, [
          _hoisted_165,
          _createElementVNode("div", _hoisted_166, [
            _createElementVNode("input", {
              value: _ctx.data.first.value,
              type: "text",
              id: "firstname",
              name: "firstname",
              placeholder: "Type your first name",
              required: ""
            }, null, 8, _hoisted_167)
          ])
        ]),
        _createElementVNode("div", _hoisted_168, [
          _hoisted_169,
          _createElementVNode("div", _hoisted_170, [
            _createElementVNode("input", {
              value: _ctx.data.last.value,
              type: "text",
              id: "lastname",
              name: "lastname",
              placeholder: "Type your last name",
              required: ""
            }, null, 8, _hoisted_171)
          ])
        ]),
        _createElementVNode("div", _hoisted_172, [
          _hoisted_173,
          _createElementVNode("div", _hoisted_174, [
            _createElementVNode("input", {
              value: _ctx.data.email.value,
              type: "text",
              id: "email",
              name: "email",
              placeholder: "Type your email",
              required: ""
            }, null, 8, _hoisted_175)
          ])
        ]),
        _createElementVNode("div", _hoisted_176, [
          _hoisted_177,
          _createElementVNode("div", _hoisted_178, [
            _createElementVNode("input", {
              type: "text",
              id: "field[42]",
              name: "field[42]",
              value: _ctx.data.job,
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_179)
          ])
        ]),
        _createElementVNode("div", _hoisted_180, [
          _hoisted_181,
          _createElementVNode("div", _hoisted_182, [
            _createElementVNode("input", {
              type: "text",
              id: "field[7]",
              name: "field[7]",
              value: _ctx.data.countryId,
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_183)
          ])
        ]),
        _createElementVNode("div", _hoisted_184, [
          _hoisted_185,
          _createElementVNode("div", _hoisted_186, [
            _createElementVNode("input", {
              type: "text",
              id: "field[6]",
              name: "field[6]",
              value: _ctx.data.region,
              placeholder: ""
            }, null, 8, _hoisted_187)
          ])
        ]),
        _createElementVNode("div", _hoisted_188, [
          _hoisted_189,
          _createElementVNode("div", _hoisted_190, [
            _createElementVNode("input", {
              type: "text",
              id: "field[51]",
              name: "field[51]",
              value: _ctx.data.organization,
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_191)
          ])
        ]),
        _createElementVNode("div", _hoisted_192, [
          _hoisted_193,
          _createElementVNode("div", _hoisted_194, [
            _createElementVNode("select", {
              value: _ctx.data.orgType,
              name: "field[54]",
              id: "field[54]",
              required: ""
            }, _hoisted_201, 8, _hoisted_195)
          ])
        ]),
        _createElementVNode("div", _hoisted_202, [
          _hoisted_203,
          _createElementVNode("div", _hoisted_204, [
            _createElementVNode("input", {
              value: _ctx.phonenum,
              type: "text",
              id: "phone",
              name: "phone",
              placeholder: "Type your phone number"
            }, null, 8, _hoisted_205)
          ])
        ]),
        _createElementVNode("div", _hoisted_206, [
          _hoisted_207,
          _createElementVNode("div", _hoisted_208, [
            _createElementVNode("input", {
              type: "text",
              id: "field[46]",
              name: "field[46]",
              value: _ctx.data.website,
              placeholder: ""
            }, null, 8, _hoisted_209)
          ])
        ]),
        _createElementVNode("div", _hoisted_210, [
          _hoisted_211,
          _createElementVNode("div", _hoisted_212, [
            _createElementVNode("select", {
              value: _ctx.data.reason,
              name: "field[55]",
              id: "field[55]",
              required: ""
            }, _hoisted_221, 8, _hoisted_213)
          ])
        ]),
        _createElementVNode("div", _hoisted_222, [
          _hoisted_223,
          _createElementVNode("div", _hoisted_224, [
            _createElementVNode("textarea", {
              value: _ctx.data.message,
              id: "field[26]",
              name: "field[26]",
              placeholder: ""
            }, null, 8, _hoisted_225)
          ])
        ]),
        _hoisted_226,
        _hoisted_227
      ]),
      _hoisted_228
    ], 512), [
      [_vShow, false]
    ]),
    _withDirectives(_createElementVNode("form", _hoisted_229, [
      _hoisted_230,
      _createElementVNode("div", _hoisted_238, [
        _createElementVNode("div", _hoisted_239, [
          _hoisted_240,
          _createElementVNode("div", _hoisted_241, [
            _createElementVNode("input", {
              value: _ctx.data.first.value,
              type: "text",
              id: "firstname",
              name: "firstname",
              placeholder: "Type your first name",
              required: ""
            }, null, 8, _hoisted_242)
          ])
        ]),
        _createElementVNode("div", _hoisted_243, [
          _hoisted_244,
          _createElementVNode("div", _hoisted_245, [
            _createElementVNode("input", {
              value: _ctx.data.last.value,
              type: "text",
              id: "lastname",
              name: "lastname",
              placeholder: "Type your last name",
              required: ""
            }, null, 8, _hoisted_246)
          ])
        ]),
        _createElementVNode("div", _hoisted_247, [
          _hoisted_248,
          _createElementVNode("div", _hoisted_249, [
            _createElementVNode("input", {
              value: _ctx.data.job,
              type: "text",
              id: "field[42]",
              name: "field[42]",
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_250)
          ])
        ]),
        _createElementVNode("div", _hoisted_251, [
          _hoisted_252,
          _createElementVNode("div", _hoisted_253, [
            _createElementVNode("input", {
              value: _ctx.data.email.value,
              type: "text",
              id: "email",
              name: "email",
              placeholder: "Type your email",
              required: ""
            }, null, 8, _hoisted_254)
          ])
        ]),
        _createElementVNode("div", _hoisted_255, [
          _hoisted_256,
          _createElementVNode("div", _hoisted_257, [
            _createElementVNode("input", {
              value: _ctx.phonenum,
              type: "text",
              id: "phone",
              name: "phone",
              placeholder: "Include country code."
            }, null, 8, _hoisted_258)
          ])
        ]),
        _createElementVNode("div", _hoisted_259, [
          _hoisted_260,
          _createElementVNode("div", _hoisted_261, [
            _createElementVNode("input", {
              value: _ctx.data.organization,
              type: "text",
              id: "field[43]",
              name: "field[43]",
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_262)
          ])
        ]),
        _createElementVNode("div", _hoisted_263, [
          _hoisted_264,
          _createElementVNode("div", _hoisted_265, [
            _createElementVNode("input", {
              value: _ctx.data.region,
              type: "text",
              id: "field[6]",
              name: "field[6]",
              placeholder: "",
              required: ""
            }, null, 8, _hoisted_266)
          ])
        ]),
        _createElementVNode("div", _hoisted_267, [
          _hoisted_268,
          _createElementVNode("div", _hoisted_269, [
            _createElementVNode("input", {
              value: _ctx.data.countryId,
              type: "text",
              id: "field[7]",
              name: "field[7]",
              placeholder: ""
            }, null, 8, _hoisted_270)
          ])
        ]),
        _createElementVNode("div", _hoisted_271, [
          _hoisted_272,
          _createElementVNode("div", _hoisted_273, [
            _createElementVNode("textarea", {
              value: _ctx.data.message,
              id: "field[26]",
              name: "field[26]",
              placeholder: ""
            }, null, 8, _hoisted_274)
          ])
        ]),
        _hoisted_275,
        _hoisted_276
      ]),
      _hoisted_277
    ], 512), [
      [_vShow, false]
    ]),
    _createVNode(_component_Tail)
  ]))
}